import SCHCTemplate from 'shared/models/SCHCTemplate';
import yup, { ErrorLengthMax, ErrorLengthMin, ERROR_REQUIRED } from 'utils/yup-form-validator';

function isAAOrAoEMode(mode: string) {
  return mode === 'ACKAlways' || mode === 'ACKOnError' || mode === 'OptimizedACKOnError';
}

const fragmentationValidator = yup.object({
  /* Fragmentation Fields */
  direction: yup.string().required(ERROR_REQUIRED),
  ruleIdSize: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  dTagSize: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  micAlgo: yup.string(),
  inactivityTime: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  winSize: yup.number().typeError('Must be a number').min(1).max(255)
    .required(ERROR_REQUIRED),
  mode: yup.string().required(ERROR_REQUIRED),

  retransmissionTime: yup.string().when('mode', {
    is: (val: string) => isAAOrAoEMode(val),
    then: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  }),

  all1RetransmissionTime: yup.string().when('mode', {
    is: (val: string) => isAAOrAoEMode(val),
    then: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  }),

  dTagReleaseTime: yup.string().when('mode', {
    is: (val: string) => isAAOrAoEMode(val),
    then: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  }),

  wSize: yup.string().when('mode', {
    is: (val: string) => isAAOrAoEMode(val),
    then: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  }),

  maxAck: yup.string().when('mode', {
    is: (val: string) => isAAOrAoEMode(val),
    then: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  }),

  tileSize: yup.string().when('mode', {
    is: 'ACKOnError',
    then: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  }),

  enableShortSessionRetransmissionTime: yup.boolean(),
  disableAll1Payload: yup.boolean(),
  sendAckEveryWindow: yup.boolean(),
});
const ruleValidator = yup.object({
  ruleId: yup.string().isNumeric().isUInt().required(ERROR_REQUIRED),
  ruleType: yup.string().required(),
  stack: yup.string()
    .when('ruleType', {
      is: SCHCTemplate.COMPRESSION_RULE,
      then: yup.string().required(),
    }),
  fragmentation: yup.object()
    .when('ruleType', {
      is: SCHCTemplate.FRAGMENTATION_RULE,
      then: fragmentationValidator,
    }),
});
const SCHCTemplateValidator = yup.object({
  name: yup.string().min(3, ErrorLengthMin(3)).max(50, ErrorLengthMax(50))
    .isAlphanumericHypenBracketSpace()
    .required(),
  description: yup.string().max(128, ErrorLengthMax(128)),
  sCHCTemplateID: yup.string().isNumeric().isInt().required(ERROR_REQUIRED), // Entier 64bits
  nonMatchingRule: yup.string().isNumeric().isInt().required(ERROR_REQUIRED), // Entier 64bits
  rules: yup.array().of(ruleValidator),
});

export default SCHCTemplateValidator;
